// src/api/authService.ts
import api from './config';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData {
  username: string;
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  user: {
    id: number;
    username: string;
    role: string;
    email: string;
  };
}

export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
  const response = await api.post('/api/auth/login', credentials);
  return response.data.data;
};

export const register = async (data: RegisterData): Promise<any> => {
  const response = await api.post('/api/auth/register', data);
  return response.data;
};

export const refreshToken = async (refresh_token: string): Promise<{ access_token: string }> => {
  const response = await api.post('/api/auth/refresh', { refresh_token });
  return response.data.data;
};
